import { anwendungslisteApi } from "@/config/httpClient"
import { Anwendung } from "@/generated/openapi"
import { sanitizeUrl } from "@braintree/sanitize-url"

class AnwendungsService {

  public getAlleAnwendungen(): Promise<Anwendung[]> {
    return anwendungslisteApi.meineAnwendungen()
      .then(resp => resp.data)
      .then(data => {
        if (!Array.isArray(data)) {
          throw new Error("invalid JSON")
        }
        return data
      })
  }

  public sortAnwendungen(arr: any) {
    return anwendungslisteApi.favoritenReihenfolge(arr)
    .then(resp => resp.data)
  }

  public getFavourites(): Promise<Anwendung[]> {
    return anwendungslisteApi.meineAnwendungen()
      .then(resp => resp.data)
      .then(anwendungen => anwendungen.filter(anwendung => !!anwendung.favorit)
      )
  }

  public openWindow(item: Anwendung) {
    // remove popup=true, we want to use window.open for new tabs too
    //let windowFeatures = "popup=true";
    let windowFeatures = "";
    if (item.window) {
      // start with dependent, so we can safely add the comma for the next properties
      if (item.window.dependent) {
        windowFeatures += "dependent=true"
      } else {
        windowFeatures += "dependent=false"
      }
      if (item.window.left && item.window.left.toString()) {
        windowFeatures += ",left=" + item.window.left.toString()
      }
      // negative screenWidth means we should add it to availWidth
      if (item.window.screenWidth && item.window.screenWidth < 0) {
        windowFeatures += ",width=" + (window.screen.availWidth + item.window.screenWidth).toString()
      } else if (item.window.screenWidth && item.window.screenWidth.toString()) {
        windowFeatures += ",width=" + item.window.screenWidth.toString()
      }
      // negative screenHeight means we should add it to availHeight
      if (item.window.screenHeight && item.window.screenHeight < 0) {
        windowFeatures += ",height=" + (window.screen.availHeight + item.window.screenHeight).toString()
      } else if (item.window.screenHeight && item.window.screenHeight.toString()) {
        windowFeatures += ",height=" + item.window.screenHeight.toString()
      }
      if (item.window.top && item.window.top.toString()) {
        windowFeatures += ",top=" + item.window.top.toString()
      }
      if (item.window.location && item.window.location.toString()) {
        windowFeatures += ",location=" + item.window.location.toString()
      }
      if (item.window.menubar) {
        windowFeatures += ",menubar=true"
      } else {
        windowFeatures += ",menubar=false"
      }
      if (item.window.resizable) {
        windowFeatures += ",resizable=true"
      } else {
        windowFeatures += ",resizable=false"
      }
      if (item.window.toolbar) {
        windowFeatures += ",toolbar=true"
      } else {
        windowFeatures += ",toolbar=false"
      }
      if (item.window.scrollbars) {
        windowFeatures += ",scrollbars=true"
      } else {
        windowFeatures += ",scrollbars=false"
      }
      if (item.window.status) {
        windowFeatures += ",status=true"
      } else {
        windowFeatures += ",status=false"
      }
      // we don't use blurfunction currently
      //if (item.window.blurfunction) {
      //}
    }
    window.open(sanitizeUrl(item.uri), item.id || item.uri, windowFeatures);
  }
}

const anwendungsService = new AnwendungsService()
export default anwendungsService
